import { CategoryPage } from "@outschool/gql-backend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";

import { TopLevelCategoryPagesQuery } from "../queries/TopLevelCategoryPages";

export const useTopLevelCategoryPagesQuery = (taxonomy?: string) =>
  useQueryWithPreviousData<{
    topLevelCategoryPages: CategoryPage[];
  }>(TopLevelCategoryPagesQuery, {
    variables: { taxonomy },
  });
